export const centralPatientConstants = {
  CENTRAL_PATIENT_LIST_REQUESTING: "CENTRAL_PATIENT_LIST_REQUESTING",
  CENTRAL_PATIENT_LIST_FETCHED: "CENTRAL_PATIENT_LIST_FETCHED",
  CENTRAL_PATIENT_LIST_FAILED: "CENTRAL_PATIENT_LIST_FAILED",

    SAVE_ACTIVE_CENTRAL_PATIENT_DATA: "SAVE_ACTIVE_CENTRAL_PATIENT_DATA",
    CLEAR_CENTRAL_PATIENT_LIST: "CLEAR_CENTRAL_PATIENT_LIST"
  };
  